import * as React from "react";

import { constants } from "../../../../../store/invoicingService";

import { useFormInstanceField } from "../../../../../store/base";
import Interval, {
  INTERVAL_MAP_SERVICECONTRACT,
} from "../../../Base/Fields/CustomFields/Interval";

export default ({ method }) => {
  const storeName = constants.STORE_NAME;

  const intervalMode = useFormInstanceField({
    storeName,
    fieldKey: "interval_setting.mode",
  });

  return (
    <>
      <Interval
        mode={intervalMode}
        storeName={storeName}
        method={method}
        baseFieldKey="interval_setting"
        config={INTERVAL_MAP_SERVICECONTRACT}
      />
    </>
  );
};
